import React from "react";

// boolean と string (必要なら number) の両方に対応するための型
export type ToggleValue = boolean | string | number;

export interface ToggleOption<T extends ToggleValue> {
  label: string;
  value: T;
  activeClass?: string; // 選択時に付与するクラス名（デフォルトは "selected" にします）
}

interface Props<T extends ToggleValue> {
  value: T;
  onChange: (value: T) => void;
  options: ToggleOption<T>[];
  className?: string; // 親 div に付与するクラス名
}

function ToggleButton<T extends ToggleValue>({
  value,
  onChange,
  options,
}: Props<T>) {
  return (
    <div className="toggle">
      {options.map((option, index) => {
        const isSelected = value === option.value;
        const activeClassName = option.activeClass || "selected";

        return (
          <label key={index} className={isSelected ? activeClassName : ""}>
            <input
              type="radio"
              checked={isSelected}
              onChange={() => onChange(option.value)}
            />
            {option.label}
          </label>
        );
      })}
    </div>
  );
}

export default ToggleButton;
